<template>
  <div class="">
    <div v-if="isShow" class="pt16 pb16 bg_white">
      <div class="title_wrap pr17">
        <SectionTitle
        :title="'売上レポート'"
        :width="''"
        />
        <a :href="ndsLpUrl" class="lc rb lp_link">LP利用状況<span class="lp_img"><img src="../../../assets/images/outbound_link.png" alt=""></span></a>
      </div>
      <SelectMonth />
      <ul class="category">
        <li class="category_list" v-for="(val, index) in affiliateList" :key="index">
          <router-link :is="!val.showDetail ? 'span' : 'router-link'" class="category_item rb" :class="{ link: val.showDetail }" :style="styleColor(val.color)" :to="{ name: 'WalletAccessDetail', query: { affiliateProductId: val.affiliateItemId } }">
            <span class="category_name">{{ val.affiliateItemName }}</span>
            <span class="category_point">￥{{ val.cashBackAmount.toLocaleString() }}</span>
          </router-link>
        </li>

        <li class="category_list">
          <div class="category_item rb" style="background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), #4FCCD4;">
            <span class="category_name">合計金額</span>
            <span class="category_point">￥{{ calcTotalPrice().toLocaleString() }}</span>
          </div>
        </li>
      </ul>
      <div class="pl16 pr16 mt16">
        <p class="alert_text ab c5a">※でんきは前月売上分、請求分のキャッシュバックが毎月第3金曜日の翌日に反映されます。</p>
      </div>
      <Chart v-if="affiliateList.length > 0" :affiliateList="affiliateList" />
      <ErrorModal v-if="isErrorModal" :errorMessage="errorMessage" @modalClose="modalClose" />
    </div>
    <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
  </div>
</template>

<script>
import Check from '@/model/getToken';
import Wallet from '@/components/api/wallet/wallet';
import SelectMonth from '@/components/wallet/SelectMonth';
import Chart from '@/components/wallet/Chart';
import SectionTitle from '@/components/common/SectionTitle';
import { mapGetters } from 'vuex';
import ErrorModal from '@/components/common/ErrorModal';

const today = new Date();
export default {
  components: {
    Chart,
    SelectMonth,
    SectionTitle,
    ErrorModal,
  },
  data() {
    return {
      isShow: true,
      affiliateList: [],
      isErrorModal: false,
      errorMessage: '',
      ndsLpUrl: '',
    }
  },
  methods: {
    modalClose() {
      this.isErrorModal = false;
    },
    styleColor(color) {
      return "background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), " + color ;
    },
    calcTotalPrice() {
      return this.affiliateList.reduce(function(sum, element){
        return sum + element.cashBackAmount;
      }, 0);
    },
    async getSalesSummaryReport() {
      await Wallet.getSalesSummaryReport(this.currentMonth).then((val) => {
        console.log('売り上げレポート');
        console.log(val);
        // if(!val) {
        //   console.log('error');
        //   this.errorMessage = 'エラーが発生しました。しばらくたってから、再度実行してください。';
        //   this.isErrorModal = true;
        // }
        // else {
          this.affiliateList.splice(0, this.affiliateList.length);
          this.affiliateList.push(...val);
        // }
      });
    },
    async getNdsLpUrl() {
      await Wallet.getNdsLpUrl(this.currentMonth).then((val) => {
        console.log('NDS URL');
        console.log(val);
        this.ndsLpUrl = val;
      });
    }
  },
  computed: mapGetters(['currentMonth']),
  async created() {
    console.log('aaa');
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.getNdsLpUrl();
      this.getSalesSummaryReport();
    } else {
      this.isShow = false;
    }
  },
  watch: {
    currentMonth() {
      this.getSalesSummaryReport();
    }
  }
}
</script>

<style lang="css" scoped>
.error_contents {
  border: 1px solid red;
  margin: 16px;
  padding: 16px;
}
.error_contents .error_text {
  color: red;
  font-size: 16px;
}
.title_wrap {
  display: flex;
  justify-content: space-between;
}
.content_title {
  padding-right: 16px;
}
.lc {
  color: #4FCCD4;
}
.lp_link {
  /* align-items: center; */
  display: flex;
}
.lp_img {
  margin-left: 5px;
  width: 15px;
}


.alert_text {
  font-size: 11px;
}



.category {
  margin-top: 24px;
}
.category_list {
  padding-left: 16px;
}
.category_list:not(:first-child) {
  margin-top: 4px;
}
.category_item {
  align-items: center;
  /* background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), #4F68D4; */
  border-radius: 100px 0 0 100px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  padding: 12px 48px 12px 16px;
  position: relative;
}
.category_item.link::before,
.category_item.link::after {
  bottom: 0;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
}
.category_item.link::before {
  border: 1px solid  #fff;
  border-radius: 50%;
  height: 24px;
  right: 16px;
  width: 24px;
}
.category_item.link::after {
  border-top: 2px solid #fff;
  border-right: 2px solid #fff;
  height: 6px;
  right: 26px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  width: 6px;
}

</style>



// WEBPACK FOOTER //
// src/views/wallet/salesSummaryReport/SalesSummaryReport.vue